<template>
    <div class="align-middle d-inline-block unexplored-marker-container">
        <div aria-label="Tab is unexplored" class="unexplored-marker rounded-circle"></div>
    </div>
</template>

<script>
export default {
    name: "UnreadMarker",
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

$marker-width: 6px;

@keyframes unex-pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}

.unexplored-marker-container {
    width: 2px;
    left: 6px;
    margin-bottom: 1px;
}

.unexplored-marker {
    width: $marker-width;
    height: $marker-width;
    background-color: $primary;
    animation: 1.5s ease-in-out 0s infinite normal both running unex-pulse;
}
</style>